import { LocalizedText, LocaleCode } from '../types/component'

/**
 * Get localized text based on locale
 */
export function getLocalizedText(
  text: string | LocalizedText | undefined,
  locale: LocaleCode = 'en'
): string {
  if (!text) return ''
  if (typeof text === 'string') return text
  return text[locale] || text.en || ''
}
